import Media from './../mediaDetect.js'; //Детектор медиа
import Twig from 'twig';

var currPageEventsUpcoming = 1;

let Main = {
    initMainSlider: function(slider, currIndexSlider){

        let currSliderContainer = $('[data-main-slider-wrap].main-slider__wrap_' + currIndexSlider),
            currDots = currSliderContainer.find('[data-main-slider-dots]'),
            autoplayTimer = 8000;

        slider.on('init', function(event, slick){
            // При инициализации слайдера устанавливаем на счётчике общее число слайдов
            var currIndexAll = (slick.$slides.length < 10) ?  '0' + slick.$slides.length: slick.$slides.length;
            currSliderContainer
                .find('[data-main-slider-final-val-dots]')
                .text(currIndexAll);

            Main.animateNavMainSlider(currDots.find('li'), 0, autoplayTimer);
        });


        slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            // Устанавливаем в счётчике номер текущего слайда
            var currIndex = (nextSlide + 1 < 10) ?
                                '0' + (nextSlide + 1):
                                (nextSlide + 1);
            currSliderContainer
                .find('[data-main-slider-curr-val-dots]')
                .text(currIndex);

            // Для первого слайда или слайдов номер которых меньше предыдущего(currentSlide)
            // очищаем заливку и стили
            if(nextSlide < currentSlide ){
                currDots.find('button').stop(true, true).removeClass('all-fill').removeAttr('style');
            }

            Main.animateNavMainSlider(currDots.find('li'), nextSlide, autoplayTimer);
        });


        slider.slick({
            adaptiveHeight: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnHover: false,
            pauseOnFocus: false,
            autoplay: true,
            autoplaySpeed: autoplayTimer,
            speed: 1200,
            fade: false,
            arrows: false,
            dots: true,
            appendDots: currDots
        });
    },
    pauseMainSlider: function(slider){
        slider.slick('slickPause');
    },
    playMainSlider: function(slider){
        slider.slick('slickPlay');
    },
    animateNavMainSlider: function(listLi, idexSlide, timer) {

        listLi.each(function(index) {
            let _this = $(this);

            // Все элементы, находящиеся перед текущим закрашиваем
            if(index < idexSlide) {
                _this.find('button').addClass('all-fill');
            }

            if(index == idexSlide){
                // Для текущего элемента запускаем анимацию заливки,
                // а после завершения анимации удаляем инлайновые стили
                // и добавляем класс заливки
                _this.find('button').animate({width: '100%'}, timer,
                    function() {
                        $(this).addClass('all-fill').removeAttr('style');
                    }
                );
            }
        });
    },
    EventsUpcoming: {
        ajaxAdd: function(listEvents, btn, allPage){
            $.ajax({
                url: '/'+window.langId+'/ajax/main-upcoming-events.php',
                data: {
                    page: currPageEventsUpcoming + 1,
                    allPage: allPage
                },
                dataType: 'json',
                beforeSend: function(){},
                success: function(_data){

                    currPageEventsUpcoming++;

                    if(allPage || (currPageEventsUpcoming >= _data.pageCount)) {
                        btn.closest('[data-wrap-btn-main-upcoming-events]').hide();
                    }

                    if(_data.list.length > 0){

                        if(Media.detect().isMobile){
                            var countSlide = listEvents.slick('getSlick').slideCount;
                            listEvents.slick('unslick');
                        }

                        var template = Twig.twig({
                            data:   '<div class="section-main-upcoming-events__card" data-card-main-upcoming-events="true">'+
                                        '<div class="event-card-full {{(data.isOwnExhibition ? \'event-card-full__own-exhibition\')}}" data-full-event-card="true">'+
                                            '<div class="row" data-full-event-card-content="true">'+
                                                '<div class="event-card-full__top col-12 d-block d-md-none">'+
                                                    '<a href="{{data.link}}" class="event-card-full__date">'+
                                                        '{{data.dateInterval|raw}}'+
                                                    '</a>'+
                                                    '{% if data.addCalendarLink|length %}'+
                                                        '<a href="{{data.addCalendarLink}}" class="event-card-full__add-calendar">'+
                                                            '<span class="svg-icon ">'+
                                                                '<svg>'+
                                                                    '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-calendar"></use>'+
                                                                '</svg>'+
                                                            '</span>'+
                                                        '</a>'+
                                                    '{% endif %}'+
                                                '</div>'+
                                                '<div class="col-12 col-md-2">'+
                                                    '{% if data.logo|length %}'+
                                                        '<a href="{{data.link}}" class="event-card-full__logo">'+
                                                            '<img src="{{data.logo}}" />'+
                                                        '</a>'+
                                                    '{% endif %}'+
                                                '</div>'+
                                                '<div class="col-12 col-md-6 col-lg-7">'+
                                                    '<a href="{{data.link}}" class="event-card-full__content">'+
                                                        '<div class="event-card-full__type">{{data.type|raw}}</div>'+
                                                        '<div class="event-card-full__title">{{data.title|raw}}</div>'+
                                                        '<div class="event-card-full__descr">{{data.descr|raw}}</div>'+
                                                        '<div class="event-card-full__info">' +
                                                            '<div class="event-card-full__organizer">'+
                                                                '<div class="event-card-full__organizer-title">{{data.organizerTitle|raw}}:</div>'+
                                                                '<div class="event-card-full__organizer-name">{{data.organizer|raw}}</div>'+
                                                            '</div>'+
                                                            '{% if data.ageRestriction|length %}'+
                                                            '<div class="event-card-full__age-restriction">' +
                                                                '{{data.ageRestriction}}' +
                                                            '</div>'+
                                                            '{% endif %}'+
                                                        '</div>'+
                                                    '</a>'+
                                                '</div>'+
                                                '<div class="col-12 col-md-4 col-lg-3 d-none d-md-block">'+
                                                    '<a href="{{data.link}}" class="event-card-full__date">'+
                                                        '{{data.dateInterval|raw}}'+
                                                    '</a>'+
                                                    '{% if data.addCalendarLink|length %}'+
                                                        '<a href="{{data.addCalendarLink}}" class="event-card-full__add-calendar">'+
                                                            '<span class="svg-icon ">'+
                                                                '<svg>'+
                                                                    '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-calendar"></use>'+
                                                                '</svg>'+
                                                            '</span>'+
                                                            '<span class="text">{{data.langAddtoCalendar|raw}}</span>'+
                                                       '</a>'+
                                                    '{% endif %}'+
                                                    '{% if data.place|length %}'+
                                                        '<a href="{{data.link}}" class="event-card-full__place">'+
                                                            '<span class="svg-icon ">'+
                                                                '<svg>'+
                                                                    '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-pin"></use>'+
                                                                '</svg>'+
                                                            '</span>'+
                                                            '<span class="text">{{data.place|raw}}</span>'+
                                                        '</a>'+
                                                    '{% endif %}'+
                                                '</div>'+
                                            '</div>'+
                                        '</div>'+
                                    '</div>'
                        });

                        _data.list.forEach(function(item, i){
                            listEvents.append(template.render({
                                data: {
                                    link: item.link,
                                    logo: item.logo,
                                    type: item.type,
                                    dateInterval: item.dateInterval,
                                    title: item.title,
                                    descr: item.descr,
                                    organizer: item.organizer,
                                    organizerTitle: item.organizerTitle,
                                    addCalendarLink: item.addCalendarLink,
                                    place: item.place,
                                    isOwnExhibition: item.isOwnExhibition,
                                    langAddtoCalendar: item.langAddtoCalendar,
                                    ageRestriction: item.ageRestriction,
                                }
                            }));
                        });

                        let countItems = _data.totalCount,
                            countItemsInTitle = $('[data-count-item-main-upcoming-events]');

                        if(countItemsInTitle.length) {
                            countItemsInTitle.text(countItems);
                        }

                        if(Media.detect().isMobile){
                            Main.initSliderEventsOnlyMobile(listEvents, '[data-full-event-card]', '[data-full-event-card-content]');
                            listEvents.slick('slickGoTo', countSlide, true);
                        }
                    }
                }
            });
        }
    },
    News: {
        initSlider: function(slider){
            slider.not('.slick-initialized').slick({
                infinite: false,
                adaptiveHeight: false,
                slidesToShow: 3,
                slidesToScroll: 3,
                pauseOnHover: false,
                pauseOnFocus: false,
                autoplay: false,
                speed: 300,
                fade: false,
                arrows: true,
                dots: true,
                prevArrow: '<div class="btn-arrow btn-arrow_left">'+
                                '<span class="svg-icon">'+
                                    '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow"></use></svg>'+
                                '</span>'+
                            '</div>',
                nextArrow: '<div class="btn-arrow">'+
                                '<span class="svg-icon">'+
                                    '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow"></use></svg>'+
                                '</span>'+
                            '</div>',
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            infinite: true,
                            speed: 100
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }
    },
    Information: {
        toggleMobileText: function(btn){
            let container = btn.closest('[data-main-information-section]'),
                text = container.find('[data-text-main-information-section]'),
                itemText = text.find('[data-item-text-main-information-section]');

            if(text.hasClass('short')) {
                var allHeightText = 0;

                itemText.each(function(index) {
                    allHeightText += $(this).outerHeight();
                });

                text.stop(true, true).animate({height: allHeightText+'px'}, 400,
                    function(){
                        text.removeClass('short').removeAttr('style');
                        btn.addClass('all');
                    }
                );
            }else {
                text.addClass('short');

                text.stop(true, true).animate({height: '380px'}, 400,
                    function(){
                        text.removeAttr('style');
                        btn.removeClass('all');
                    }
                );
            }
        }
    },
    setHeightSlider: function(slider, itemSelector, itemContentSelector) {
        let maxHeightCard = 0;

        slider.find(itemSelector).each(function(index) {
            let _this = $(this),
                heightCardContent = _this.find(itemContentSelector).outerHeight(true),
                heightCard = heightCardContent + (_this.outerHeight() - _this.height());

            if(heightCard > maxHeightCard){
                maxHeightCard = heightCard;
            }
        });

        slider.find('.slick-track').height(maxHeightCard);
    },
    initSliderEventsOnlyMobile: function(slider, itemSelector, itemContentSelector){
        let sliderConfig = {
            infinite: false,
            adaptiveHeight: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnHover: false,
            pauseOnFocus: false,
            autoplay: false,
            speed: 300,
            fade: false,
            arrows: false,
            dots: true
        }

        slider.on('init', function(event, slick){
            Main.setHeightSlider(slider, itemSelector, itemContentSelector);
        });

        slider.on('setPosition', function(event, slick){
            Main.setHeightSlider(slider, itemSelector, itemContentSelector);
        });

        if(Media.detect().isMobile){
            slider.slick(sliderConfig);
        }

        $(window).resize(function(event) {
            var initSlider = slider.hasClass('slick-slider');

            if(Media.detect().isMobile && !initSlider){
                slider.slick(sliderConfig);
            }

            if(!Media.detect().isMobile && initSlider){
                slider.slick('unslick');
            }
        });
    },
    initSliderEvents: function(slider, itemSelector, itemContentSelector) {
        slider.on('init', function(event, slick){
            Main.setHeightSlider(slider, itemSelector, itemContentSelector);
        });

        slider.on('setPosition', function(event, slick){
            Main.setHeightSlider(slider, itemSelector, itemContentSelector);
        });

        var countItemsDesktop = 4;
        if(slider.find(itemSelector).length == 3) {
            countItemsDesktop = 3;
        }

        slider.slick({
            infinite: false,
            adaptiveHeight: false,
            slidesToShow: countItemsDesktop,
            slidesToScroll: countItemsDesktop,
            pauseOnHover: false,
            pauseOnFocus: false,
            autoplay: false,
            speed: 1200,
            fade: false,
            arrows: true,
            dots: true,
            prevArrow: '<div class="btn-arrow btn-arrow_left">'+
                            '<span class="svg-icon">'+
                                '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow"></use></svg>'+
                            '</span>'+
                        '</div>',
            nextArrow: '<div class="btn-arrow">'+
                            '<span class="svg-icon">'+
                                '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow"></use></svg>'+
                            '</span>'+
                        '</div>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        speed: 300
                    }
                }
            ]
        });
    }
}

$(document).ready(function($) {

    // Главный слайдер
    let mainSlider = $('[data-main-slider]');
    if(mainSlider.length){

        mainSlider.each(function(index) {
            let _this = $(this);

            if(!_this.hasClass('slick-initialized')) {

                _this.closest('[data-main-slider-wrap]')
                    .addClass('main-slider__wrap_'+index);

                Main.initMainSlider(_this, index);
            }
        });
    }

    // Текущие выставки и мероприятия
    let mainCurrEventsSlider = $('[data-main-curr-events]');
    if(mainCurrEventsSlider.length){
        if(mainCurrEventsSlider.hasClass('isSliderDesktop')){
            Main.initSliderEvents(mainCurrEventsSlider, '[data-event-card]', '[data-event-card-content]');
        }else{
            Main.initSliderEventsOnlyMobile(mainCurrEventsSlider, '[data-full-event-card]', '[data-full-event-card-content]');
        }
    }

    // Ближайшие выставки и мероприятия
    let mainUpcomingEventsList = $('[data-main-upcoming-events]');
    if(mainUpcomingEventsList.length){

        Main.initSliderEventsOnlyMobile(mainUpcomingEventsList, '[data-full-event-card]', '[data-full-event-card-content]');

        $('[data-btn-more-main-upcoming-events]').on('click', function(e){
            e.preventDefault();
            Main.EventsUpcoming.ajaxAdd(mainUpcomingEventsList, $(this), false);
        });
    }

    // Новости
    let mainNewsList = $('[data-main-news-list]');
    if(mainNewsList.length){
        Main.News.initSlider($('[data-tab-news-main].active').find('[data-main-news-list]'));

        $('[data-nav-tab-news-main]').on('click', function(){
            let $this = $(this);

            if(!$this.hasClass('active')) {

                let type = $this.data('nav-tab-news-main'),
                    $tabCurrent = $('[data-tab-news-main="'+ type +'"]'),
                    $sliderCurr = $tabCurrent.find('[data-main-news-list]');

                $('[data-nav-tab-news-main]').removeClass('active');
                $('[data-btn-tab-news-main]').removeClass('active');
                $('[data-tab-news-main]').removeClass('active');
                
                $('[data-nav-tab-news-main="'+ type +'"]').addClass('active');
                $('[data-btn-tab-news-main="'+ type +'"]').addClass('active');
                $tabCurrent.addClass('active');

                if($sliderCurr.hasClass('slick-initialized')) {
                    $sliderCurr.slick('destroy');
                }
                Main.News.initSlider($sliderCurr);
            }  
        });
    }

    // Секция с текстом
    let mainBtnAllTextInformation = $('[data-btn-main-information-section]');
    if(mainBtnAllTextInformation.length){

        mainBtnAllTextInformation.on('click', function(e){
            e.preventDefault();

            Main.Information.toggleMobileText($(this));
        });
    }

    // Фоновое видео перед контактами
    let videoMainpageContacts = $('.js-video-mainpage-contacts');
    if(videoMainpageContacts.length) {

        $(window).on('scroll', function(event) {
            var currScroll = $(window).scrollTop(),
                windowHeight = $(window).outerHeight(),
                $bgVideoContacts = $('[data-bg-video-mainpage-contacts]'),
                topBgVideoContacts = $bgVideoContacts.offset().top,
                headerHeight = $('[data-header-bottom]').outerHeight();

            if((currScroll >= topBgVideoContacts - windowHeight) && (currScroll <= topBgVideoContacts + $bgVideoContacts.outerHeight() - headerHeight)) {
                if(!videoMainpageContacts.hasClass('play')) {
                    videoMainpageContacts.addClass('play').get(0).play();
                }
            }else{
                if(videoMainpageContacts.hasClass('play')) {
                    videoMainpageContacts.removeClass('play').get(0).pause();
                }
            }
        });
    }
});

export default {
    pauseMainSlider: Main.pauseMainSlider,
    playMainSlider: Main.playMainSlider
};



// WEBPACK FOOTER //
// ./components/main.js